import { gql } from 'shared/types/gradoo'

export const USER_GROUP = gql(/* GraphQL */ `
  query UserGroup($id: ID!) {
    userGroup(id: $id) {
      ...UserGroup
    }
  }
`)
